import React from "react";
import styles from "./JournalEntryDrawerHeader.module.scss";

interface JournalEntryDrawerHeaderProps {
    children: React.ReactNode;
}

export const JournalEntryDrawerHeader: React.FC<
    JournalEntryDrawerHeaderProps
> = ({ children }) => (
    <header>
        <h5 className={styles.title}>{children}</h5>
    </header>
);
